export default __webpack_public_path__ + "static/media/total-pemasukan.d8d02290.svg";